<template lang="html">

    <div class="contenedor-popup-info">

        <span @click="open = !open">{{(open) ? '✕' : 'i'}}</span>
        <div class="popup" v-if="open">
            <a @click="open = false" class="cerrar">✕</a>
            <p v-html="texts[id].cuerpo"></p>
        </div>

    </div>

</template>

<script lang="js">
    export default {
        name: 'oferta',
        props:['id'],
        data(){
            return{
                open : false,
                texts : {
                    'envio-proactivo' : {
                        'cuerpo' : 'Si desactivas esta opción, solo se trabajará con tu candidatura en las ofertas en que tú te inscribas.'
                    },
                    'informacion-interes' : {
                        'cuerpo' : 'Puestos, áreas funcionales y sectores de tu interés y notas para el equipo UDP. Longitud maxima 150 carácteres'
                    }
                }
            }
        }

    }
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/parts/popup-info.vue